import fetch from 'utils/fetch'

// 号源情况
export function fetchOverview(params) {
  return fetch({
    url: '/reservation/confReservationPool/hasNumberSource',
    params
  })
}

// 接种时间段
export function fetchTime(params) {
  return fetch({
    url: '/reservation/confReservationPool/workdayTime',
    params
  })
}

// 预约下单
export function subscribe(data) {
  return fetch({
    method: 'POST',
    url: '/reservation/appReservation/subscribe',
    data
  })
}

// 预约详情
export function subscribeDetail(params) {
  return fetch({
    url: '/reservation/appReservation/home/appointments',
    params
  })
}

// 免规苗订单校验
export function validateImm(params) {
  return fetch({
    url: '/reservation/vaccineV3/vaccines/immunization/canSubscribe',
    params
  })
}

// 非免规苗订单校验
export function validateNotImm(params) {
  return fetch({
    url: '/reservation/vaccineV3/vaccines/notImmunization/canSubscribe',
    params
  })
}